// Models
/**
 * The chat thread type, whether it's a task's or a plan's chat thread.
 */ export var PlannerChatThreadType = /*#__PURE__*/ function(PlannerChatThreadType) {
    /** The thread for task chat */ PlannerChatThreadType["Task"] = "task";
    /** The thread for plan chat */ PlannerChatThreadType["Plan"] = "plan";
    return PlannerChatThreadType;
}({});
/**
 * The types of identities that can be mentioned in a message
 */ export var ChatMentionType = /*#__PURE__*/ function(ChatMentionType) {
    ChatMentionType["User"] = "user";
    ChatMentionType["Application"] = "application";
    return ChatMentionType;
}({});
/**
 * The Chat message type whether rich text or plaintext
 */ export var ChatMessageType = /*#__PURE__*/ function(ChatMessageType) {
    ChatMessageType["RichText"] = "richTextHtml";
    ChatMessageType["Text"] = "plainText";
    return ChatMessageType;
}({});
